"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipeNodeGroup = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
class PipeNodeGroup {
    constructor(mainPipeNodes, childPipeNodes) {
        this._mainPipeNodes = mainPipeNodes;
        this._childPipeNodes = childPipeNodes;
    }
    getMinDis(node) {
        let nodes = new Array();
        nodes = nodes.concat(this._mainPipeNodes);
        nodes = nodes.concat(this._childPipeNodes);
        let minDis = Number.POSITIVE_INFINITY;
        for (let selfNode of nodes) {
            let dis = node._point.distance(selfNode._point);
            minDis = Math.min(minDis, dis);
        }
        return minDis;
    }
    getPipeSegments() {
        //由于中途涉及到加点和转坐标，所以这里的_segment缓存暂时注释
        /*if (this._segments)
          return this._segments;*/
        this._segments = new Array();
        if (this._mainPipeNodes.length > 0) { //正常情况下MainPipeNodes数量为1
            this.traverseToGetSegments(this._mainPipeNodes[0]);
        }
        return this._segments;
    }
    traverseToGetSegments(node) {
        for (let child of node._children) {
            /*if (this._childPipeNodes.indexOf(child) < 0) {
              return;
            }*/
            //仅获取内部线段
            if (this._mainPipeNodes.indexOf(child) < 0 && this._childPipeNodes.indexOf(child) < 0) {
                continue;
            }
            this._segments.push(new LineSegment_js_1.default(node._point, child._point));
            this.traverseToGetSegments(child);
        }
    }
}
exports.PipeNodeGroup = PipeNodeGroup;
